/* eslint-disable no-undef */
import { mapGetters } from 'vuex'

var ga4 = {
  data () {
    return {
      debug: false // 開關：true = console.log, false = 送 GA
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    // === 共用發送事件 ===
    sendEvent (eventName, payload = {}) {
      if (this.debug) {
        console.log(`[GA4 DEBUG] ${eventName}`, payload)
        return
      }
      if (typeof gtag === 'function') {
        gtag('event', eventName, payload)
      } else {
        console.warn('gtag not found:', eventName, payload)
      }
    },

    // === 商品資料格式化 ===
    return_item (value) {
      if (!value) return []
      const buildItem = (item) => {
        if (!item) return null
        const newItem = {
          item_id: item.id || '',
          item_name: item.name || '',
          price: Number(item.pricing) || 0,
          quantity: item.quantity || 1,
          item_category: item.type || ''
        }
        if (item.discount) newItem.discount = item.discount
        if (item.category_id) newItem.item_list_id = item.category_id
        return newItem
      }
      return Array.isArray(value)
        ? value.map(item => buildItem(item)).filter(Boolean)
        : [buildItem(value)]
    },

    // === 使用者屬性 ===
    set_user_properties () {
      if (!this.user) return
      gtag('set', 'user_properties', {
        role: this.user.role || '',
        plan: this.user.plan || '',
        device: navigator.userAgent
      })
    },

    // === 錯誤追蹤 ===
    track_error (action, message) {
      this.sendEvent('exception', {
        description: `${action}: ${message}`,
        fatal: false
      })
    },

    // === 電商事件 ===
    add_payment_info (item) {
      this.sendEvent('add_payment_info', {
        currency: 'TWD',
        value: Number(this.total) || 0,
        payment_type: this.paymentInfo?.payment || '',
        items: this.return_item(item)
      })
    },

    add_shipping_info (item) {
      this.sendEvent('add_shipping_info', {
        currency: 'TWD',
        value: Number(this.total) || 0,
        shipping_tier: this.paymentInfo?.payment || '',
        items: this.return_item(item)
      })
    },

    add_to_cart (item) {
      this.sendEvent('add_to_cart', {
        currency: 'TWD',
        value: Number(item.pricing) || 0,
        items: this.return_item(item)
      })
    },

    remove_from_cart (item) {
      this.sendEvent('remove_from_cart', {
        currency: 'TWD',
        value: Number(item.pricing) || 0,
        items: this.return_item(item)
      })
    },

    add_to_wishlist (data) {
      this.sendEvent('add_to_wishlist', {
        currency: 'TWD',
        value: Number(data.pricing) || 0,
        items: this.return_item(data)
      })
    },

    begin_checkout (data) {
      this.sendEvent('begin_checkout', {
        currency: 'TWD',
        value: Number(this.total) || 0,
        coupon: this.paymentInfo?.couponCode || '',
        items: this.return_item(data)
      })
    },

    purchase_track (orderData, products) {
      const obj = {
        transaction_id: orderData.order_id,
        value: Number(this.total) || 0,
        shipping: Number(this.paymentInfo?.shipping_fee) || 0,
        currency: 'TWD',
        coupon: this.paymentInfo?.couponCode || '',
        items: this.return_item(products)
      }
      this.sendEvent('purchase', obj)
    },

    // refund_track (orderId, amount, items) {
    //   this.sendEvent('refund', {
    //     transaction_id: orderId,
    //     value: Number(amount) || 0,
    //     currency: 'TWD',
    //     items: this.return_item(items)
    //   })
    // },

    search_track (keyword) {
      this.sendEvent('search', { search_term: keyword })
    },

    view_cart (data) {
      this.sendEvent('view_cart', {
        currency: 'TWD',
        value: Number(this.total) || 0,
        items: this.return_item(data.items)
      })
    },

    view_item (data) {
      this.sendEvent('view_item', {
        currency: 'TWD',
        value: Number(data.pricing) || 0,
        items: this.return_item(data)
      })
    },

    view_item_list (dataObj, data) {
      this.sendEvent('view_item_list', {
        item_list_id: dataObj.category || '',
        item_list_name: dataObj.type || '',
        items: this.return_item(data.data)
      })
    },

    select_promotion (data) {
      this.sendEvent('select_promotion', {
        promotion_id: data.id,
        promotion_name: data.name
      })
    },

    // === 使用者行為 ===
    login_track () {
      if (!this.user) return
      this.sendEvent('login', { method: 'Website' })
    },

    sign_up_track () {
      if (!this.user) return
      this.sendEvent('sign_up', {
        user_id: this.user.id,
        method: 'Website'
      })
    }

    // generate_lead (formName) {
    //   this.sendEvent('generate_lead', {
    //     form_name: formName || 'unknown',
    //     method: 'Website'
    //   })
    // }
  }
}

export default ga4
